// extracted by mini-css-extract-plugin
module.exports = {"root":"UserInfoCard_root__NY_Zv","box":"UserInfoCard_box__R_zde","btnIcon":"UserInfoCard_btnIcon__Z6GsD"};